import { PublicClientApplication } from '@azure/msal-browser'
import { apiRequest } from '../auth/config'

let _msalInstance: PublicClientApplication | null = null

export function setMsalInstance(instance: PublicClientApplication) {
  _msalInstance = instance
}

async function getToken(): Promise<string> {
  if (!_msalInstance) throw new Error('MSAL instance not set')
  const account = _msalInstance.getActiveAccount() ?? _msalInstance.getAllAccounts()[0]
  if (!account) throw new Error('No active account')
  const result = await _msalInstance.acquireTokenSilent({ ...apiRequest, account })
  return result.accessToken
}

const BASE = import.meta.env.VITE_API_URL as string

export async function apiFetch<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  const token = await getToken()
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body ? { 'Content-Type': 'application/json' } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`${method} ${path} → ${res.status}: ${text}`)
  }
  const text = await res.text()
  return text ? (JSON.parse(text) as T) : (null as T)
}

/** Multipart upload — let the browser set the multipart boundary (no Content-Type). */
export async function apiUpload<T>(path: string, formData: FormData): Promise<T> {
  const token = await getToken()
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`POST ${path} → ${res.status}: ${text}`)
  }
  const text = await res.text()
  return text ? (JSON.parse(text) as T) : (null as T)
}

/** Authenticated binary GET → Blob (anchor tags can't carry the bearer token). */
export async function apiBlob(path: string): Promise<Blob> {
  const token = await getToken()
  const res = await fetch(`${BASE}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`GET ${path} → ${res.status}: ${text}`)
  }
  return res.blob()
}
